import { format, parseISO } from '@if/core/date'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import { DocsAutomation } from '@src/types/automationDocument'
import { useTranslation } from 'react-i18next'

const toUtc = (date: string) => (date.endsWith('Z') ? date : date + 'Z')

interface MessageDialogProps {
  docsAutomation: DocsAutomation | null
  onClose: () => void
}

const MessageDialog = ({ docsAutomation, onClose }: MessageDialogProps) => {
  const { t } = useTranslation()

  return (
    <Dialog open={Boolean(docsAutomation)} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        {t('docsAutomation.message')}
        {docsAutomation && (
          <>
            <Typography variant="subtitle2" color="text.secondary">
              {docsAutomation.email?.sentBy} ({docsAutomation.email?.senderEmail})
              {' — '}
              {t('docsAutomation.receivedOn', {
                date: format(parseISO(toUtc(docsAutomation.email?.receivedOn ?? docsAutomation.createdOn)), 'PPPP'),
              })}
            </Typography>
            {docsAutomation.email?.subject && (
              <Typography variant="subtitle1" gutterBottom>
                {docsAutomation.email.subject}
              </Typography>
            )}
          </>
        )}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap' }}>
          {docsAutomation?.email?.message}
        </Typography>
      </DialogContent>
      <DialogActions>
        {docsAutomation?.email?.webLink && (
          <Button
            component="a"
            href={docsAutomation.email.webLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('common.openInOutlook')}
          </Button>
        )}
        <Button onClick={onClose}>{t('common.close')}</Button>
      </DialogActions>
    </Dialog>
  )
}

export default MessageDialog
